import { IFilterDTO, IInstitutionUpdate, IInstitutionCriteria } from '../../types/types';
import authService from '../../components/api-authorization/AuthorizeService';
import { createFilterCriteria } from '../../utilities/filterCriteria';

export const getInstitutionList = async (filter: IFilterDTO[]) => {
    
    let criteria = createFilterCriteria(filter) as IInstitutionCriteria;

    try {

        let response = await fetch(`api/Institution/InstitutionList`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'                
            },
            body: JSON.stringify(criteria)
        });

        if (!response.ok) {

            throw new Error("Failed to get insititution list.");
            
        }

        return response.json();

    }

    catch (exception) {

        console.error(exception)
        throw exception;

    }

};


export const getInstitutionTypeAsync  = async () => {
    try {
        

        let response = await fetch(`api/Institution/GetAllInstitutionTypes`);

        if (!response.ok) {

            throw new Error("Failed to get all insititution types.");

        }

        return response.json();

    }

    catch (exception) {

        console.error(exception)
        throw exception;

    };
}

export const updateInstitutionAsync = async (institution: IInstitutionUpdate) => {

    try {
            let response = await fetch(`api/institution/saveInstitution`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(institution)
            });

            if (!response.ok) {
                throw new Error("Failed to update insititution.");
            }

            return response.json();
    }
    catch (exception) {
        console.error(exception)
        throw exception;
    };

};

export const getCountriesStatesAsync = async () => {

    try {

        

        let response = await fetch(`api/Institution/GetCountriesAndStates`);

        if (!response.ok) {

            throw new Error("Failed to get countries and states list.");

        }

        return response.json();

    }

    catch (exception) {

        console.error(exception)
        throw exception;

    };
}


export const getInstitutionByIdAsync  = async (id: number) => {

    

    try {

        let response = await fetch(`api/Institution/details/${id}`);

        if (!response.ok) {

            throw new Error("Failed to get insititution by Id.");

        }

        return response.json();

    }

    catch (exception) {

        console.error(exception)
        throw exception;

    }

};